<template>
    <va-form :id="id" :item="item">
        <v-row justify="center">
            <v-col sm="6">
                <base-material-card>
                    <template v-slot:heading>
                        <div class="display-2">
                            {{ title }}
                        </div>
                    </template>
                    <v-card-text>
                        <va-text-input source="name"></va-text-input>
                        <va-text-input
                            source="email"
                            type="email"
                        ></va-text-input>

                        <va-autocomplete-input
                            label="Departamente"
                            model="departments"
                            multiple
                            filled
                            reference="departments"
                            source="departments"
                        ></va-autocomplete-input>

                        <va-autocomplete-input
                            label="Roluri"
                            model="roles"
                            filled
                            multiple
                            reference="roles"
                            source="roles"
                        ></va-autocomplete-input>

                        <va-password-input
                            source="password"
                        ></va-password-input>
                        <va-password-input
                            source="password_confirmation"
                        ></va-password-input>
                    </v-card-text>
                    <va-save-button></va-save-button>
                </base-material-card>
            </v-col>
        </v-row>
    </va-form>
</template>

<script>
export default {
    props: ["id", "item", "title"]
};
</script>
